import { Component, inject, Signal, ChangeDetectionStrategy } from '@angular/core';
import { Toast } from '../../../models/local/toast.model';
import { ToastService } from '../../../services/local/toast.service';
import { ToastComponent } from '../item/toast.component';

@Component({
  selector: 'immo-toast-stack',
  imports: [
    ToastComponent
  ],
  templateUrl: './toast-stack.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './toast-stack.component.css',
})
export class ToastStackComponent {

  // -----------------------------------------------------------------------------------------------------
  // @ DEPENDENCIES
  // -----------------------------------------------------------------------------------------------------

  private readonly toastService: ToastService = inject(ToastService);

  // -----------------------------------------------------------------------------------------------------
  // @ PUBLIC INSTANCE VARIABLES
  // -----------------------------------------------------------------------------------------------------

  readonly toasts: Signal<Toast[]> = this.toastService.toasts;

  // -----------------------------------------------------------------------------------------------------
  // @ PUBLIC METHODS
  // -----------------------------------------------------------------------------------------------------

  /**
   * Dismiss a toast.
   * 
   * @param toast - The toast to dismiss.
   * @returns {void}
   */
  dissmiss(toast: Toast): void {
    this.toastService.dismiss(toast);
  }
}